"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const spinnerStyle = (0, _styledSystem.variant)({
  key: "spinners"
});

const StyledSpinnerCircle = _styledComponents2.default.circle.withConfig({
  displayName: "Spinner__StyledSpinnerCircle",
  componentId: "evvtq4-0"
})(["stroke:", ";"], p => p.color ? p.theme.colors[p.color] : p.theme.colors.blue);

const SpinnerAnimation = (0, _styledComponents.keyframes)(["100%{transform:rotate(360deg);}"]);

const StyledSpinner = _styledComponents2.default.svg.withConfig({
  displayName: "Spinner__StyledSpinner",
  componentId: "evvtq4-1"
})(["animation:", " 0.75s linear infinite;", ";"], SpinnerAnimation, spinnerStyle);

const Spinner = props => _react2.default.createElement(
  StyledSpinner,
  props,
  _react2.default.createElement(StyledSpinnerCircle, { color: props.color })
);

Spinner.propTypes = {
  color: _propTypes2.default.string
};

exports.default = Spinner;